import { Container, Row, Col } from "react-bootstrap";
import MobileFooter from "../components/mobileFooter";
import MobileNavigationBar from "../components/mobileNavbar";
import tutoring from "../assets/tutoring.jpg";
import quran from "../assets/quran.png";

const EducationMobile = () => {
    return (
        <div className="position-relative">
            <MobileNavigationBar />

            <div
                style={{
                    backgroundColor: "#AAC5AB",
                    fontFamily: "Lora, serif",
                    minHeight: "25vh",
                    padding: "20px 0"
                }}
            >
                <Container className="text-center">
                    <div className="d-flex flex-column align-items-center justify-content-center">
                        <div style={{ maxWidth: "90%" }}>
                            <h1 
                                className="fw-bold mb-3" 
                                style={{ 
                                    fontSize: "1.8rem", 
                                    lineHeight: "1.3",
                                    color: "#000"
                                }}
                            >
                                Educational Programs
                            </h1>
                            <p 
                                className="mb-0"
                                style={{ 
                                    fontSize: "1rem", 
                                    lineHeight: "1.4",
                                    color: "#333"
                                }}
                            >
                                Accessible education programs in English, Quran, and technology—
                                helping children build skills and confidence for the future.
                            </p>
                        </div>
                    </div>
                </Container>
            </div>

            <Container className="my-4">
                <Row>
                    <Col>
                        <h2>Tutoring</h2>
                        <p style={{ textAlign: "justify" }}>
                            We provide English tutoring to Quran students of all ages, focusing on more than just grammar.
                            Our tutors help students learn how to read, write, speak, and engage in everyday conversational English.
                            This includes important life lessons like classroom rules, personal hygiene, and conversational manners.
                        </p>
                        <p style={{ textAlign: "justify" }}>
                            Additionally, we offer tutoring in specific subjects as needed and provide college guidance to support academic success beyond language skills.
                        </p>
                        <img
                            src={tutoring}
                            alt="tutoring"
                            style={{
                                width: "80%",
                                height: "40%",
                                maxHeight: "300px",
                                objectFit: "cover",
                                display: "block",
                                margin: "auto",
                            }}
                        />
                    </Col>
                </Row>

                <Row className="my-5">
                    <Col>
                        <h2>Quran Classes</h2>
                        <p style={{ textAlign: "justify" }}>
                            Our Quran classes equip children with the tools to read, understand, and live by its teachings.
                            The goal is not only to learn the faith but to develop strong character.
                        </p>
                        <p style={{ textAlign: "justify" }}>
                            We strive to make the Quran easily accessible to all children so everyone can learn to read and understand its message.
                        </p>
                        <img
                            src={quran}
                            alt="quran"
                            style={{
                                width: "80%",
                                height: "auto",
                                maxHeight: "300px",
                                objectFit: "cover",
                                display: "block",
                                margin: "auto",
                            }}
                        />
                    </Col>
                </Row>
            </Container>

            <MobileFooter />
        </div>
    );
};

export default EducationMobile;
